import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { ReactSearchAutocomplete } from "react-search-autocomplete";
import { removePriceList } from "./removePriceList";
export var productDoList = [
    {
        key: "warehouseID",
        render: function(param) {
            var item = param.item, values = param.values, optionsWarehouse = param.optionsWarehouse, setProductRow = param.setProductRow;
            var _item_warehouseID;
            return /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx("td", {
                        children: item.productID && /*#__PURE__*/ _jsxs("select", {
                            value: (_item_warehouseID = item.warehouseID) !== null && _item_warehouseID !== void 0 ? _item_warehouseID : "",
                            style: {
                                width: "100%",
                                border: !item.warehouseID ? "1px solid #dc3545" : "1px solid rgb(223, 225, 229)"
                            },
                            onChange: function(e) {
                                setProductRow(function(prev) {
                                    return prev.map(function(el) {
                                        var selectedOption = e.target.options[e.target.selectedIndex];
                                        if (el.rowID === item.rowID) {
                                            return _object_spread_props(_object_spread({}, el), {
                                                warehouseID: e.currentTarget.value,
                                                warehouseName: selectedOption.text
                                            });
                                        }
                                        return el;
                                    });
                                });
                            },
                            className: "form-control sselectv",
                            disabled: true,
                            children: [
                                /*#__PURE__*/ _jsx("option", {
                                    value: "",
                                    disabled: true,
                                    children: "เลือกคลัง"
                                }, "default"),
                                optionsWarehouse && optionsWarehouse.map(function(v, index) {
                                    return /*#__PURE__*/ _jsx("option", {
                                        value: v.value,
                                        children: v.label
                                    }, index);
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("td", {
                        className: "column_resizer_body"
                    })
                ]
            });
        }
    },
    {
        key: "edit",
        render: function(param) {
            var item = param.item, setProductRow = param.setProductRow, addProductRow = param.addProductRow, productSearch = param.productSearch, handleOnSelect = param.handleOnSelect, handleOnClear = param.handleOnClear, handleOnFocus = param.handleOnFocus, handleOnSearch = param.handleOnSearch, formatResult = param.formatResult, rowCount = param.rowCount, index = param.index;
            return /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx("td", {
                        children: !item.edit ? /*#__PURE__*/ _jsx("button", {
                            className: "btn btn-shadow fs-14",
                            style: {
                                width: "100%",
                                height: "100%",
                                display: "flex",
                                minHeight: "35px"
                            },
                            onClick: function(e) {
                                setProductRow(function(prev) {
                                    return prev.map(function(el) {
                                        if (el.rowID === item.rowID) {
                                            return _object_spread_props(_object_spread({}, el), {
                                                edit: true
                                            });
                                        }
                                        return el;
                                    });
                                });
                                if (rowCount - index <= 2) {
                                    addProductRow(2);
                                }
                            },
                            disabled: item.soItemID,
                            children: item.productCode
                        }) : /*#__PURE__*/ _jsx(ReactSearchAutocomplete, {
                            items: productSearch,
                            placeholder: "",
                            onSelect: function(items) {
                                return handleOnSelect(items, item.rowID);
                            },
                            onClear: handleOnClear,
                            onFocus: handleOnFocus,
                            onSearch: handleOnSearch,
                            autoFocus: true,
                            formatResult: formatResult,
                            fuseOptions: {
                                keys: [
                                    "barcode",
                                    "dimProduct.name_th"
                                ]
                            },
                            resultStringKeyName: "barcode",
                            inputSearchString: item.barcode,
                            styling: {
                                height: "34px",
                                borderRadius: "10px",
                                border: 0,
                                fontSize: "14px",
                                boxShadow: "none",
                                zIndex: 1
                            },
                            showIcon: false,
                            showClear: false,
                            className: "scrollSearchAutocomplete",
                            disabled: true
                        })
                    }),
                    /*#__PURE__*/ _jsx("td", {
                        className: "column_resizer_body"
                    })
                ]
            });
        }
    },
    {
        key: "productQty",
        render: function(param) {
            var values = param.values, item = param.item, setProductRow = param.setProductRow, filterDisplay = param.filterDisplay;
            var finalRemainingQty = item.deliveredQty === 0 && item.remainingQty === 0 ? item.item_so_quantity : item.remainingQty;
            return /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx("td", {
                        className: "!bg-[#FFEDE0]",
                        children: item.productID != "" ? /*#__PURE__*/ _jsx("input", {
                            type: "number",
                            className: "form-control formv text-center border-0 me-2 bg-[#FFEDE0] ".concat(Number(item.productQty) > finalRemainingQty ? "bg-red-400" : "bg-[#FF6B00]"),
                            value: item.productQty,
                            onFocus: function(e) {
                                return e.target.select();
                            },
                            onWheel: function(e) {
                                return e.target.blur();
                            },
                            onChange: function(e) {
                                setProductRow(function(prev) {
                                    return prev.map(function(el) {
                                        if (el.rowID === item.rowID) {
                                            return _object_spread_props(_object_spread({}, el), {
                                                productQty: e.target.value
                                            });
                                        }
                                        return el;
                                    });
                                });
                            },
                            maxQty: values.fact_new_so_id && finalRemainingQty > 0 ? finalRemainingQty : undefined
                        }) : ""
                    }),
                    /*#__PURE__*/ _jsx("td", {
                        className: "column_resizer_body !bg-[#FFEDE0]"
                    })
                ]
            });
        }
    },
    {
        insertBefore: "ums",
        key: "soQty",
        render: function(param) {
            var item = param.item, values = param.values;
            var finalRemainingQty = item.deliveredQty === 0 && item.remainingQty === 0 ? item.item_so_quantity : item.remainingQty;
            if (!values.fact_new_so_id) return null;
            return /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx("td", {
                        style: {
                            backgroundColor: "#EDEDFF"
                        },
                        children: finalRemainingQty
                    }),
                    /*#__PURE__*/ _jsx("td", {
                        className: "column_resizer_body  bg-EDEDFF "
                    })
                ]
            });
        }
    },
    {
        key: "productsStock",
        remove: true,
        render: function() {
            return null;
        }
    }
].concat(_to_consumable_array(removePriceList));
